import { ChangeEvent, useContext } from 'react';
import { Tooltip } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-pro';

import { GridNumberInput } from '@styles/GridStyles';
import { INumberInputProps } from '../../inputs/NumberInput';
import { GridRowContext } from './PhoenixGrid';


interface IGridColNumberProps extends INumberInputProps {
  params: GridRenderEditCellParams;
  isRelatedToStartDate?: string;
  disabled?: boolean;
  onChange?(event: ChangeEvent<HTMLInputElement>): void;
}

export const GridColNumber = ({ params, disabled = false, onChange, ...rest }: IGridColNumberProps) => {
  const api = useGridApiContext();
  const rowContext = useContext(GridRowContext);
  const { id, field, value } = params;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (rowContext.errors[field]) {
      rowContext.resetError(field);
    }

    api.current.setEditCellValue({ id, field, value: event.target.value });
    onChange?.(event);
  };

  return (
    <Tooltip title={rowContext.errors[field]}>
      <div>
        <GridNumberInput
          {...rest}
          unStyled={false}
          disabled={disabled}
          value={String(value)}
          error={Boolean(rowContext.errors[field])}
          onChange={handleChange}
        />
      </div>
    </Tooltip>
  );
};
